/* eslint-disable @typescript-eslint/no-explicit-any */
import {SystemConstants} from "common/system-constants";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import HttpClient from "./http-client";
import {APIHosts, ApiReduxHelpers} from "./reduxHelpers";

export interface ExtractFileRequest {
  guid_file: string;
  path_file: string;
}

export interface FileAnalytic {
  _id: string;
  guid_file: string;
  name_file: string;
  path_file: string;
    file_id_project: string;
    irai_id: string;
    type_extract: string;
  };

 export interface FileAnalyticStatus {
     _id: string;
    irai_id: string;
    guid_file: string;
    type: string;
    sum_page: number;
    current_page: number;
    status: string;
    verify: boolean;
  }
class DOCAIController extends ApiReduxHelpers {
  constructor() {
    super();
  }

  ApiHost = APIHosts.DOCAI;

  extractFileByPathFile(data: ExtractFileRequest): Observable<FileAnalytic> {
    const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_DOCAI.API.FILE.EXTRACT_FILE_BY_PATH}`;
    return HttpClient.post(url, data).pipe(map((res) => res as FileAnalytic));
  }

  getTaskByGuidFile(guid_file: string): Observable<FileAnalyticStatus> {
    const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_DOCAI.API.TASK.GET_BY_GUID(guid_file)}`;
    return HttpClient.get(url).pipe(map((res) => res as FileAnalyticStatus));
  }
}

export const DOCAIApi = new DOCAIController();
